import { h } from 'preact'
import { useRef, useEffect, useMemo, useCallback } from 'preact/hooks'
import PropTypes from 'prop-types'

import classNames from 'lib/classNames'

import './index.sass'

export default function Select(props){
  const {
    disabled,
    unsaved,
    className,
    onClick,
    value,
    autoFocus,
    options,
    lpignore,
    placeholder,
    name,
    onChange: propsOnChange,
    onBlur: propsOnBlur,
    ...rest
  } = props

  const selectRef = useRef()

  useEffect(() => {
    if (autoFocus && selectRef.current) selectRef.current.focus()
  }, [autoFocus])

  const onChange = useMemo(
    () => propsOnChange && (event => propsOnChange(event.target.value, event)),
    [propsOnChange]
  )

  const onBlur = useCallback(
    (event) => {
      if (propsOnBlur) propsOnBlur(event)
    },
    [propsOnBlur]
  )

  return <div {...{
    className: classNames('Select', {unsaved, disabled, className}),
    onClick,
    disabled: disabled ? 'disabled' : undefined,
  }}>
    <select {...{
      ...rest,
      name,
      ref: selectRef,
      value: value ?? '',
      disabled,
      'data-lpignore': lpignore ? 'true' : 'false',
      onChange,
      onBlur,
    }}>
      {placeholder && <option value="" disabled hidden>{placeholder}</option>}
      {options.map(({value, label}) => (
        <option value={value} key={value}>{label}</option>
      ))}
    </select>
  </div>
}

Select.propTypes = {
  disabled: PropTypes.bool,
  unsaved: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  autoFocus: PropTypes.bool,
  lpignore: PropTypes.bool,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
}

Select.defaultProps = {
  className: '',
  lpignore: true,
  autoFocus: false,
  placeholder: '',
}
